export const FAQTypes = {
  MODAL_EDIT_FAQ_TYPE_VISIBLE: "MODAL_EDIT_FAQ_TYPE_VISIBLE",
  MODAL_ANSWER_VISIBLE: "MODAL_ANSWER_VISIBLE",
  GET_FAQ_LIST: "GET_FAQ_LIST",
  GET_FAQ_TYPE: "GET_FAQ_TYPE",
  SET_FAQ_DETAIL: "SET_FAQ_DETAIL",
};